import styles from "./StartupLibrary.module.scss";
import { GreetingsHeader } from '../../components/common/GreetingsHeader';
import { Info } from '../../components/Info';
import { DataTableComp } from '../../components/DataTable';

export const StartupLibrary = () => {
    return (
        <div className={styles.wrapper}>
            <GreetingsHeader title="Start-up library - All scans" subtitle=""/>
            {/*<section className={styles.infoContainer}>*/}
            {/*    <Info*/}
            {/*        title="Startup bibliotheek - Introductie"*/}
            {/*        description="Welkom bij de startup bibliotheek. In deze bibliotheek vind je alle startups die de ConsistentieScan hebben opgestart en afgerond.*/}

            {/*        In de bibliotheek vind je de laatst gerealiseerde ConsistentieScan en Questionnaire per onderneming. Met de knop “Scan aanvragen” kun je een startup uitnodigen om een nieuwe ConsistentieScan in te vullen."*/}
            {/*    />*/}
            {/*</section>*/}
            <section className={styles.navigate}>
                <DataTableComp></DataTableComp>
            </section>
        </div>
    )
};
